import {IFilterState} from 'plugins/modules/filter/types';
import {GLOBAL_FILTER_ACTIONS} from 'plugins/modules/filter/actions';
import {ActionReducerMapBuilder, PayloadAction} from '@reduxjs/toolkit';

export function addFilterExtraReducers<T extends IFilterState>(builder: ActionReducerMapBuilder<T>) {
    builder.addCase(
        GLOBAL_FILTER_ACTIONS.actionSetIsFilterPanelVisible.type,
        (state, {payload}: PayloadAction<boolean>) => {
            state.isFilterPanelVisible = payload;
        },
    );
}
